import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagComponent } from './tag/tag.component';
import { SystemIconModule } from '../system-icon/system-icon.module';



@NgModule({
  declarations: [
    TagComponent
  ],
  imports: [
    CommonModule,
    SystemIconModule
  ],
  exports: [
    TagComponent
  ]
})
export class TagsModule { }
